<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-mb-card">
    <v-col class="com-mb-card-contents py-1">
      <v-row>
        <span class="pl-4 pt-2">{{text.label}}</span>
        <v-slider
          v-model="opacity"
          max="100"
          min="0"
          hide-details="auto"
          step="10"
          always-dirty
          :thumb-size="24"
          class="px-2"
        ></v-slider>
      </v-row>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [mb]レーダ雨量画面 透過設定カード
 * RdOpacity.vue
 * @author LIS
 */
import mixin from "../../lib/mixin.js";
export default {
  name: "rd-opacity",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        label: "透過率",
      },
    };
  },
  computed: {
    /** 透過率 */
    opacity: {
      get() {
        return this.$store.state.radar.radarOpacity;
      },
      set(val) {
        this.$store.commit("radar/setOpacity", val);
        this.replaceRadarQueryForMb();
      },
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
